// extracted by mini-css-extract-plugin
module.exports = {"button":"QuantityButton_button__M0x1l"};